import { preloadImage } from './utils';

class LazyImg {
  static get URL_META() {
    return '[name="cloudinary-url"]';
  }

  static get SELECTOR() {
    return '.js-lazy-img';
  }

  static get HANDLED_CLASS() {
    return 'loaded';
  }

  static get GRID() {
    return {
      maxWidth: 1920,
      column: 68,
      gutter: 30,
    };
  }

  constructor() {
    this.baseUrl = document
      .querySelector(LazyImg.URL_META)
      .getAttribute('content');

    this.imgParams = ['c_fill', 'f_auto', 'q_98', 'b_white'].join(',');
    this.bgParams = ['c_fill', 'f_auto', 'q_98', 'b_white'].join(',');

    if (this.baseUrl === '' || this.baseUrl === undefined) {
      return;
    }

    this.getImages();
  }

  getImages = () => {
    this.images = [...document.querySelectorAll(LazyImg.SELECTOR)];
    if ('IntersectionObserver' in window) {
      this.initObserver();
      return;
    }

    this.loadAll(this.images);
  };

  isHandled(image) {
    return image.classList.contains(LazyImg.HANDLED_CLASS);
  }

  initObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }

    const intersectionConfig = {
      threshold: 0.01,
    };

    this.observer = new IntersectionObserver(
      this.onIntersection,
      intersectionConfig,
    );

    this.observeImages();
  }

  observeImages() {
    this.count = this.images.length;
    this.images.filter(image => !this.isHandled(image)).forEach(image => {
      this.observer.observe(image);
    });
  }

  onIntersection = entries => {
    entries.filter(entry => entry.intersectionRatio > 0).forEach(entry => {
      this.count--;
      this.observer.unobserve(entry.target);
      this.loadImage(entry.target);
    });

    if (this.count === 0) {
      this.observer.disconnect();
    }
  };

  snapToGrid(renderWidth) {
    const colCalc = n =>
      n * (LazyImg.GRID.column + LazyImg.GRID.gutter) - LazyImg.GRID.gutter;
    let ncols = 1;
    let snapWidth = 0;
    while (snapWidth < LazyImg.GRID.maxWidth) {
      snapWidth = colCalc(ncols);
      if (renderWidth - snapWidth <= 0) {
        return colCalc(ncols);
      }
      ncols++;
    }
    return LazyImg.GRID.maxWidth;
  }

  loadAll(images) {
    images
      .filter(image => !this.isHandled(image))
      .forEach(image => this.loadImage(image));
  }

  loadImage(image) {
    const id = image.dataset.src;

    if (!id) {
      return;
    }

    let { width, height } = image.getBoundingClientRect();
    if (width === 0 || height === 0) {
      return;
    }

    if (image.tagName === 'IMG') {
      this.applyImg(image, id, width);
    } else {
      this.applyBg(image, id, width, height);
    }
  }

  applyImg(image, id, width) {
    const imageParams = [
      'w_' + this.snapToGrid(width * 2),
      this.imgParams,
      image.dataset.ratio && `ar_${image.dataset.ratio}`,
      //window.devicePixelRatio > 1.5 && 'dpr_2.0',
    ]
      .filter(Boolean)
      .join(',');

    const url = `${this.baseUrl}/${imageParams}/${id}`;
    preloadImage(url)
      .then(_ => {
        image.removeAttribute('srcset');
        image.setAttribute('src', url);
        image.classList.add(LazyImg.HANDLED_CLASS);
      })
      .catch(_ => console.error(`Image ${url} is broken`));
  }

  applyBg(image, id, width, height) {
    const imageParams = [
      `w_${this.snapToGrid(width)},h_${
        height > 1000 ? 1000 : 100 * Math.round(height / 100)
      }`,
      this.imgParams,
      //window.devicePixelRatio > 1.5 && 'dpr_2.0',
    ]
      .filter(Boolean)
      .join(',');
    const url = `${this.baseUrl}/${imageParams}/${id}`;

    preloadImage(url)
      .then(_ => {
        image.style.backgroundImage = `url(${url})`;
        image.classList.add(LazyImg.HANDLED_CLASS);
      })
      .catch(_ => console.error(`Image ${url} is broken`));
  }
}

export const lazyImg = new LazyImg();



// WEBPACK FOOTER //
// ./src/js/lazy-img.js